/** Brand colour helpers (WCAG 2.1 relative luminance). No dependencies. */
function rgb(h) {
    const n = parseInt(h.slice(1), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function toHex([r, g, b]) {
    return ('#' +
        [r, g, b]
            .map((v) => Math.round(Math.min(255, Math.max(0, v)))
            .toString(16)
            .padStart(2, '0'))
            .join(''));
}
function luminance(h) {
    const lin = (v) => {
        const c = v / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    };
    const [r, g, b] = rgb(h);
    return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
}
export function contrastRatio(a, b) {
    const la = luminance(a);
    const lb = luminance(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
/** Mix a colour toward white (amount > 0) or black (amount < 0). */
export function mixColor(h, amount) {
    const target = amount >= 0 ? 255 : 0;
    const t = Math.abs(amount);
    return toHex(rgb(h).map((v) => v + (target - v) * t));
}
/** The colour, darkened just enough to reach `min` contrast against `on` (default white). */
export function ensureContrast(h, min = 4.5, on = '#ffffff') {
    let c = h;
    for (let i = 0; i < 40 && contrastRatio(c, on) < min; i++)
        c = mixColor(h, -(i + 1) * 0.025);
    return c;
}
/**
 * The band a brand's logos sit on. Logos drawn for a dark background go on
 * black; logos with dark artwork ("light") go on white, with dark text.
 */
export function bandColors(logoBackground) {
    return logoBackground === 'light'
        ? { bg: '#ffffff', fg: '#111827', light: true }
        : { bg: '#000000', fg: '#ffffff', light: false };
}
//# sourceMappingURL=brand-colors.js.map